import React from 'react';
import './NotificationItem.css';

const NotificationItem = ({ 
  notification, 
  icon, 
  timeAgo, 
  isRead, 
  onClick 
}) => {
  const truncateMessage = (message, maxLength = 80) => {
    if (message.length <= maxLength) {
      return message;
    }
    return message.substring(0, maxLength) + '...';
  };

  return (
    <div 
      className={`notification-item ${isRead ? 'read' : 'unread'}`}
      onClick={onClick}
    >
      <div className="notification-item-content">
        <div className="notification-icon">
          {icon}
        </div>
        <div className="notification-text">
          <p className="notification-message">
            {truncateMessage(notification.message)}
          </p>
          <span className="notification-time">
            {timeAgo}
          </span>
        </div>
        {!isRead && (
          <div className="notification-unread-indicator"></div>
        )}
      </div>
    </div>
  );
};

export default NotificationItem;
